import { render, staticRenderFns } from "./WatermarkBlend.vue?vue&type=template&id=56e22908&scoped=true&"
import script from "./WatermarkBlend.vue?vue&type=script&lang=ts&"
export * from "./WatermarkBlend.vue?vue&type=script&lang=ts&"
import style0 from "./WatermarkBlend.vue?vue&type=style&index=0&id=56e22908&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e22908",
  null
  
)

export default component.exports